<template>
  <div>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td>
              <input
                type="text"
                class="form-control"
                id="nombreBusqueda"
                name="nombreBusqueda"
                v-model="nombreBusqueda"
                style="width: 500px; text-transform: uppercase"
                required
              />
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Buscar registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >search</i
                >
                Buscar
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Todos los registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >auto_awesome_motion</i
                >
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Fecha</th>
          <th scope="col">Hora</th>
          <th scope="col">Estado</th>
          <th scope="col">Especialidad</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cita in datosPaginados" :key="cita.idCita">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(cita.idCita)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ getFormattedDate(cita.fechaCita, "DD/MM/YYYY") }}</td>
          <td>{{ cita.horaDesde }}</td>
          <td>{{ cita.estadoCita }}</td>
          <td>{{ cita.nombreEspecialidad }}</td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPaginaTodos(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idCita" class="form-label">IdCita</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idCita"
                      name="idCita"
                      v-model="datoCita.idCita"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombreMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="nombreMedico"
                      name="nombreMedico"
                      v-model="datoCita.nombreMedico"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombreEspecialidad" class="form-label">
                      Especialidad</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="nombreEspecialidad"
                      name="nombreEspecialidad"
                      v-model="datoCita.nombreEspecialidad"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombreMotivoCita" class="form-label">
                      Motivo Cita</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="nombreMotivoCita"
                      name="nombreMotivoCita"
                      v-model="datoCita.nombreMotivoCita"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaCita" class="form-label">FechaCita</label>
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaCita"
                      name="fechaCita"
                      :value="getFormattedDate(datoCita.fechaCita)"
                      disabled
                    />
                  </div>
                  <div class="col-2">
                    <label for="estadoCita" class="form-label"
                      >EstadoCita</label
                    >
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="estadoCita"
                      name="estadoCita"
                      v-model="datoCita.estadoCita"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="horaDesde" class="form-label">HoraDesde</label>
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="horaDesde"
                      name="horaDesde"
                      v-model="datoCita.horaDesde"
                      disabled
                    />
                  </div>
                  <div class="col-2">
                    <label for="horaHasta" class="form-label">HoraHasta</label>
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="horaHasta"
                      name="horaHasta"
                      v-model="datoCita.horaHasta"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="descripcion" class="form-label"
                      >Descripción</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="descripcion"
                      name="descripcion"
                      v-model="datoCita.descripcion"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="observacion" class="form-label"
                      >Observación</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="observacion"
                      name="observacion"
                      v-model="datoCita.observacion"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioReg" class="form-label"
                      >IdUsuarioReg</label
                    >
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuarioReg"
                      name="idUsuarioReg"
                      v-model="datoCita.idUsuarioReg"
                      disabled
                    />
                  </div>
                  <div class="col-2">
                    <label for="fechaReg" class="form-label"
                      >Fecha de registro</label
                    >
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaReg"
                      name="fechaReg"
                      :value="getFormattedDate(datoCita.fechaReg)"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioAct" class="form-label"
                      >IdUsuarioAct</label
                    >
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuarioAct"
                      name="idUsuarioAct"
                      v-model="datoCita.idUsuarioAct"
                      disabled
                    />
                  </div>
                  <div class="col-2">
                    <label for="fechaAct" class="form-label">FechaAct</label>
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaAct"
                      name="fechaAct"
                      :value="getFormattedDate(datoCita.fechaAct)"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;

export default {
  props: {
    p_idPersona: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      citas: [],
      datoCita: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      personas: [],
      horarios: [],
      medicos: [],
      especialidads: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.citas.length / this.elementosPorPagina);
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwcitas/idpersona/" + this.p_idPersona
        )
        .then((response) => {
          this.citas = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.citas.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = [
        "idHorario",
        "idMedico",
        "idEspecialidad",
        "fechaCita",
        "horaDesde",
        "horaHasta",
        "estadoCita",
        "descripcion",
        "observacion",
      ];
      const requiredFieldsText = [
        "idPersona",
        "idHorario",
        "idMedico",
        "idEspecialidad",
        "fechaCita",
        "horaDesde",
        "horaHasta",
        "estadoCita",
        "descripcion",
        "observacion",
      ];
      return validarForm(this.datoCita, requiredFields, requiredFieldsText);
    },
    abrirModalEditar(idCita) {
      this.modalWindow = true;
      if (idCita != null) {
        api.get("/vwcitas/" + idCita)
          .then((resp) => {
            this.datoCita = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Resumen de la cita";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    async deleteCita(idCita) {
      try {
        await api.delete("/citas/" + idCita);
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
  },
};
</script>
